import script from "./AdminSkinPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSkinPicker.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSkinPicker.vue?vue&type=style&index=0&id=086888c8&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-086888c8"]])

export default __exports__